document.addEventListener("teeinblue-event-component-injected", function () {
  const insertAfterElement = document.querySelector(".tee-product-price");
  const productBlocks = document.querySelectorAll(".product-block");
  let elementToMove = null;
  let elementToMove2 = null;
  productBlocks.forEach((block) => {
    if (block.textContent.trim() == "Limited time deal") {
      elementToMove = block;
    }
  });
  productBlocks.forEach((block) => {
    if (
      block.textContent.includes(
        "Black Friday Starts Early: 40% OFF – Lowest Price of the Year!"
      )
    ) {
      console.log(block);
      elementToMove2 = block;
    }
  });
  if (elementToMove2 && insertAfterElement) {
    insertAfterElement.after(elementToMove2);
  }
  if (elementToMove && insertAfterElement) {
    insertAfterElement.after(elementToMove);
  }
});

document.addEventListener('teeinblue-event-component-injected', function() {
    const elementToMove3 = document.querySelector('.promo-bar-container');
    const insertAfterElement3 = document.querySelector('.tee-product-price');
    if (elementToMove3 && insertAfterElement3) {        
     insertAfterElement3.after(elementToMove3)
    } 

    const elementToMove4 = document.querySelector('.after-price-block');
    const insertAfterElement4 = document.querySelector('.tee-product-price');
    if (elementToMove4 && insertAfterElement4) {        
     insertAfterElement4.after(elementToMove4)
    } 
});

(function() {
    function handleSlideCartUpdates() {
        const propertyValues = document.querySelectorAll('#slidecarthq .properties-key-value-value');
        propertyValues.forEach(el => {
            if (el.querySelector('a')) return;
            const text = el.textContent.trim();
            if (text.includes('/customers/uploads/') && (text.startsWith('http://') || text.startsWith('https://'))) {
                el.innerHTML = `<a class="pplr_slide" href="${text}" target="_blank" rel="noopener noreferrer">Click To View Image</a>`;
            }
        });

        fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
                cart.items.forEach(item => {
                    if (item.properties && item.properties._customization_image) {
                        const imgEl = document.querySelector(`.item[data-line-item-key="${item.key}"] img`);
                        if (imgEl && imgEl.src !== item.properties._customization_image) {
                            imgEl.src = item.properties._customization_image;
                        }
                    }
                });
            })
            .catch(err => console.error('Lỗi fetch cart update:', err));
    }

    const checkSlideCartExist = setInterval(() => {
        const slideCartRoot = document.querySelector('#slidecarthq');
        if (slideCartRoot) {
            clearInterval(checkSlideCartExist);

            const observer = new MutationObserver((mutations) => {
                handleSlideCartUpdates();
            });

            observer.observe(slideCartRoot, {
                childList: true,
                subtree: true,
                characterData: true
            });

            handleSlideCartUpdates();
        }
    }, 500);

    document.addEventListener('click', (e) => {
        if (e.target.closest('#slidecarthq') || e.target.closest('[class*="slidecart"]')) {
            setTimeout(handleSlideCartUpdates, 300);
        }
    });
})();